module.exports = __webpack_public_path__ + "static/media/arrow2.9070490b.svg";